export interface WorkerResponse {
  id: number;
  result: unknown;
}

export interface ProgressMessage {
  progress: number;
}

export type WorkerMessage = WorkerResponse | ProgressMessage;

export function isProgressMessage(msg: WorkerMessage): msg is ProgressMessage {
  return "progress" in msg && typeof msg.progress === "number";
}
